module.exports = __webpack_public_path__ + "img/cattunnel35.7fff93b7.jpg";